import EnterpriseSSOExperiments from 'bundles/epic/clients/EnterpriseSSO';

export const isForcedSSOLoginFlowEnabled = () => EnterpriseSSOExperiments.get('enableForceSsoLoginV2Beta');

export const allowUniqueRecoveryEmail = ({ orgId }: { orgId: string }) => {
  const epicValue = EnterpriseSSOExperiments.get('uniqueRecoveryEmailRestriction');
  return epicValue[orgId] ?? false;
};
